import gql from 'graphql-tag'

export const fetchOrderableUnitsQuery = gql(`
  query ($customerType: String, $orderType: String) {
    getPortalConfig(customerType: $customerType, orderType: $orderType) {
        orderableunits
    }
  }
`)
